import React from 'react';
import { TrendingUp, AlertTriangle, BookOpen, Target } from 'lucide-react';

interface WallStatsProps {
  totalTopics: number;
  coveredTopics: number;
  gapTopics: number;
}

export default function WallStats({ totalTopics, coveredTopics, gapTopics }: WallStatsProps) {
  const coveragePercent = Math.round((coveredTopics / totalTopics) * 100);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {[
        {
          id: 'stat-total',
          icon: BookOpen,
          value: totalTopics,
          label: 'Curated Topics',
          sub: 'Across 7 historical eras',
          color: 'var(--primary)',
          bg: '#E05A4710',
        },
        {
          id: 'stat-covered',
          icon: TrendingUp,
          value: coveredTopics,
          label: 'Topics Covered',
          sub: 'At or above threshold',
          color: '#7DC48D',
          bg: '#5B9E6B11',
        },
        {
          id: 'stat-gaps',
          icon: AlertTriangle,
          value: gapTopics,
          label: 'Documented Gaps',
          sub: 'Contributions needed',
          color: '#E8C86A',
          bg: '#D4A84711',
        },
        {
          id: 'stat-pct',
          icon: Target,
          value: `${coveragePercent}%`,
          label: 'Archive Coverage',
          sub: 'Of minimum thresholds met',
          color: 'var(--primary)',
          bg: '#E05A4710',
        },
      ].map((stat) => (
        <div
          key={stat.id}
          className="rounded-xl border p-5"
          style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
        >
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center mb-3"
            style={{ backgroundColor: stat.bg, color: stat.color }}
          >
            <stat.icon size={18} />
          </div>
          <div
            className="text-3xl font-bold tabular-nums mb-0.5"
            style={{ color: stat.color }}
          >
            {stat.value}
          </div>
          <div className="text-sm font-medium mb-0.5" style={{ color: 'var(--foreground)' }}>
            {stat.label}
          </div>
          <div className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
            {stat.sub}
          </div>
        </div>
      ))}
    </div>
  );
}